import React from "react";
import styles from "./RegisterLinks.module.scss";

interface RegisterLinksProps {
  text: string;
  linkText: string;
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const RegisterLinks: React.FC<RegisterLinksProps> = ({ text, linkText, onLinkClick }) => {
  return (
    <div className={styles.links_register}>
      {text}
      <a href="#" className={styles.link} onClick={onLinkClick}>
        {linkText}
      </a>
    </div>
  );
};

